module.exports = __webpack_public_path__ + "img/sintesis.997969d7.svg";